import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { PrivateRoutesRoutingModule } from './private-routes-routing.module';
import { Route, Router, Routes } from '@angular/router';
import { NavService, Menu } from '../../services/nav-service.service';
import { LoginComponent } from '../../auth/login/login.component';
import { ContentLayoutComponent } from '../../shared/components/layout/content-layout/content-layout.component';
import { FlytAuthGuard } from '../../guards/flyt-auth-guard.guard';
import { AuthService } from '../../services/auth-service.service';
import { Error404Component } from '../../pages/error-pages/error404/error404.component';
import { User } from '../../types/types';
import { map, pipe, Subscription, tap } from 'rxjs';
import { DashboardModule } from 'src/app/modules/dashboard/dashboard.module';
import { DefaultComponent } from 'src/app/modules/dashboard/default/default.component';
import { HttpErrorResponse } from '@angular/common/http';
import {RouterModule} from '@angular/router';
import { ListCustomerComponent } from '../../modules/customer/list-customer/list-customer.component';
import { ListProductComponent } from '../../modules/product/list-product/list-product.component';
import { ListQrCodeBatchComponent } from '../../modules/qrcodes/list-qr-code-batch/list-qr-code-batch.component';
import { ListRedeemRequestsComponent } from '../../modules/redeem-requests/list-redeem-requests/list-redeem-requests.component';
import { RedeemRequestDetailsComponent } from '../../modules/redeem-requests/redeem-request-details/redeem-request-details.component';
import { NewRedeemRequestComponent } from '../../modules/redeem-requests/new-redeem-request/new-redeem-request.component';
import { BotMessagesComponent } from '../../modules/bot-messages/bot-messages/bot-messages.component';
import { MessageTemplatesComponent } from '../../modules/whatsapp-bulk/message-templates/message-templates.component';
import { CampaignSetupComponent } from '../../modules/whatsapp-bulk/campaign-setup/campaign-setup.component';
import { CampaignsListComponent } from '../../modules/whatsapp-bulk/campaigns-list/campaigns-list.component';
import { CampaignDetailsComponent } from '../../modules/whatsapp-bulk/campaign-details/campaign-details.component';
import { AnalyticsDashboardComponent } from '../../modules/whatsapp-bulk/analytics-dashboard/analytics-dashboard.component';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    PrivateRoutesRoutingModule,
    RouterModule
  ],
  exports:[
    RouterModule
  ]
})
export class PrivateRoutesModule {

  public menuItems: Menu[];

  constructor(private router: Router, public navServices: NavService, private authService: AuthService) {
    const routes: Routes = [
      {
        path: 'auth/login',
        component: LoginComponent
      },
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'dashboard'
      },
      {
        path: '',
        component: ContentLayoutComponent,
        pathMatch:'prefix',
        canActivate: [FlytAuthGuard],
        children: [
          {
            title: 'Dashboard', 
            path: 'dashboard',
            canActivate: [FlytAuthGuard],
            component: DefaultComponent,
            data: {
              breadcrumb: {
                label: 'Dashboard',
              },
              active: true,
              type: 'link',
              icon: 'home',
              role: 'ROLE_ADMIN',
              animation: 'slideInAnimation'
            },
          },
          {
            title: 'All Redeem Requests',
            path: 'redeem-requests',
            canActivate: [FlytAuthGuard],
            children: [
              {
                path: '',
                pathMatch: 'full',
                canActivate: [FlytAuthGuard],
                component: ListRedeemRequestsComponent,
                data: {
                  title:"All Redeem Requests",
                  breadcrumb: {
                    label: "All Redeem Requests",
                    info: 'icofont icofont-files'
                  },
                  icon: 'home',
                  active: true,
                  type: 'link',
                  role: 'ROLE_ADMIN',
                  animation: 'slideInAnimation'
                }
              },
              {
                path: ':id',
                canActivate: [FlytAuthGuard],
                component: RedeemRequestDetailsComponent,
                data: {
                  title:"Enquiry Details",
                  breadcrumb: {
                    label: "Enquiry Details",
                    info: 'icofont icofont-files',
                  },
                  icon: 'home',
                  active: true,
                  type: 'link',
                  role: 'ROLE_ADMIN',
                  animation: 'slideInAnimation'
                }
              }
            ]
          },
          {
            title: 'All Customers',
            path: 'customers',
            canActivate: [FlytAuthGuard],
            children: [
              {
                path: '',
                pathMatch: 'full',
                canActivate: [FlytAuthGuard],
                component: ListCustomerComponent,
                data: {
                  title:"All Customers",
                  breadcrumb: {
                    label: "All Customers",
                    info: 'icofont icofont-files'
                  },
                  icon: 'file-plus',
                  type: 'link',
                  active: false,
                  role: 'ROLE_ADMIN',
                  dealerEmployee: 'false',
                  animation: 'slideInAnimation'
                }
              }
            ]
          },
          {
            title: 'All Dealer Employees',
            path: 'dealer-employees',
            canActivate: [FlytAuthGuard],
            children: [
              {
                path: '',
                pathMatch: 'full',
                canActivate: [FlytAuthGuard],
                component: ListCustomerComponent,
                data: {
                  title:"All Dealer Employees",
                  breadcrumb: {
                    label: "All Dealer Employees",
                    info: 'icofont icofont-files'
                  },
                  icon: 'file-plus',
                  type: 'link',
                  active: false,
                  role: 'ROLE_ADMIN',
                  dealerEmployee: 'true',
                  animation: 'slideInAnimation'
                }
              }
            ]
          },
          {
            title: 'WhatsApp Messages',
            path: 'whatsapp-bulk',
            canActivate: [FlytAuthGuard],
            children: [
              {
                path: 'templates',
                pathMatch: 'full',
                canActivate: [FlytAuthGuard],
                component: MessageTemplatesComponent,
                data: {
                  title: 'Message Templates',
                  breadcrumb: { label: 'Message Templates', info: 'icofont icofont-files' },
                  icon: 'file-plus', type: 'link', active: false, role: 'ROLE_ADMIN', animation: 'slideInAnimation'
                }
              },
              {
                path: 'campaign-setup',
                pathMatch: 'full',
                canActivate: [FlytAuthGuard],
                component: CampaignSetupComponent,
                data: {
                  title: 'Setup a Campaign',
                  breadcrumb: { label: 'Setup a Campaign', info: 'icofont icofont-files' },
                  icon: 'file-plus', type: 'link', active: false, role: 'ROLE_ADMIN', animation: 'slideInAnimation'
                }
              },
              {
                path: 'campaigns',
                pathMatch: 'full',
                canActivate: [FlytAuthGuard],
                component: CampaignsListComponent,
                data: {
                  title: 'Campaigns',
                  breadcrumb: { label: 'Campaigns', info: 'icofont icofont-files' },
                  icon: 'file-plus', type: 'link', active: false, role: 'ROLE_ADMIN', animation: 'slideInAnimation'
                }
              },
              {
                path: 'campaigns/:id',
                canActivate: [FlytAuthGuard],
                component: CampaignDetailsComponent,
                data: {
                  title: 'Campaign Details',
                  breadcrumb: { label: 'Campaign Details', info: 'icofont icofont-files' },
                  icon: 'file-plus', type: 'link', active: false, role: 'ROLE_ADMIN', animation: 'slideInAnimation'
                }
              },
              {
                path: 'analytics',
                pathMatch: 'full',
                canActivate: [FlytAuthGuard],
                component: AnalyticsDashboardComponent,
                data: {
                  title: 'Spend & Analytics',
                  breadcrumb: { label: 'Spend & Analytics', info: 'icofont icofont-files' },
                  icon: 'file-plus', type: 'link', active: false, role: 'ROLE_ADMIN', animation: 'slideInAnimation'
                }
              }
            ]
          },
          {
            title: 'Bot Messages',
            path: 'bot-messages',
            canActivate: [FlytAuthGuard],
            children: [
              {
                path: '',
                pathMatch: 'full',
                canActivate: [FlytAuthGuard],
                component: BotMessagesComponent,
                data: {
                  title:"Bot Messages",
                  breadcrumb: {
                    label: "Bot Messages",
                    info: 'icofont icofont-files'
                  },
                  icon: 'message-square',
                  type: 'link',
                  active: false,
                  role: 'ROLE_ADMIN',
                  animation: 'slideInAnimation'
                }
              }
            ]
          },
          {
            title: 'All Products',
            path: 'products',
              canActivate: [FlytAuthGuard],
              children: [
                {
                  path: '',
                  pathMatch: 'full',
                  canActivate: [FlytAuthGuard],
                  component: ListProductComponent,
                  data: {
                    title:"All Products",
                    breadcrumb: {
                      label: "All Products",
                      info: 'icofont icofont-files'
                    },
                    icon: 'file-plus',
                    type: 'link',
                    active: false,
                    role: 'ROLE_ADMIN',
                    animation: 'slideInAnimation'
                  }
                }
              ]
          },
          {
            title: 'All QRCode Batches',
            path: 'qrcode-batches',
              canActivate: [FlytAuthGuard],
              children: [
                {
                  path: '',
                  pathMatch: 'full',
                  canActivate: [FlytAuthGuard],
                  component: ListQrCodeBatchComponent,
                  data: {
                    title:"All QRCode Batches",
                    breadcrumb: {
                      label: "All QRCode Batches",
                      info: 'icofont icofont-files'
                    },
                    icon: 'file-plus',
                    type: 'link',
                    active: false,
                    role: 'ROLE_ADMIN',
                    animation: 'slideInAnimation'
                  }
                }
              ]
          },
          {
            title: 'New redeem Request',
            path: 'new-redeem-request',
              canActivate: [FlytAuthGuard],
              children: [
                {
                  path: '',
                  pathMatch: 'full',
                  canActivate: [FlytAuthGuard],
                  component: NewRedeemRequestComponent,
                  data: {
                    title:"New redeem Request",
                    breadcrumb: {
                      label: "New redeem Request",
                      info: 'icofont icofont-files'
                    },
                    icon: 'file-plus',
                    type: 'link',
                    active: false,
                    role: 'ROLE_ADMIN',
                    animation: 'slideInAnimation'
                  }
                }
              ]
          },
        ],
        data: {
          role: 'ROLE_USER,ROLE_ADMIN,ROLE_DIRECTOR,ROLE_NOTIFIER',
          breadcrumb: {
            label: 'Home',
          }
        }
      },
      {
        path: 'error',
        loadChildren: () => import('../../pages/error-pages/error-pages.module').then(m => m.ErrorPagesModule),
      },
      {
        path: '**',
        component: Error404Component,
      }
    ];      
      this.router.resetConfig(routes); 
  }
}
